import React, { Component } from 'react';

class Guests extends Component {
  constructor(props) {
    super(props);
    this.incrementRoom = this.incrementRoom.bind(this)
    this.decrementRoom  = this.decrementRoom.bind(this)
    this.handleFocus = this.handleFocus.bind(this)
    this.closeModal = this.closeModal.bind(this)
    this.showTooltip = this.showTooltip.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  state = {
    countRoom: 1,
    countAdult: 2,
    countKid: 0,
    showModal: false,
    tooltip: false,
    finalValue:'',
    kidAge : [],
    text_cosi: <div className="cosi_text">{Drupal.t("HOW MANY")} <span>{ Drupal.t("GUESTS ?")}</span></div>
    
  };

  handleChange = (key, e) => {
    this.setState ({
      kidAge : {
        ...this.state.kidAge,
        [e.target.id] : e.target.value
      }
    })
  }

  handleFocus = (e) => {
    this.setState({
      showModal: true
    })
  }

  showTooltip = (e) => {
    this.setState(function(previousState, currentProps) {
      return {
        tooltip: !previousState.tooltip
      }
    });
  }

  closeModal = (e) => {
    let value = this.state.countAdult + Drupal.t(" Adults \u00b7 ") + this.state.countKid + Drupal.t(" Children \u00b7 ") + this.state.countRoom + Drupal.t(" rooms ");
    this.setState({
      showModal: false,
      finalValue: value
    })
    let age = Object.values(this.state.kidAge);
    if ( age.length < this.state.countKid ) {
      let n = this.state.countKid - age.length
      for (let i = 0; i < n; i++) {
          age.push('1');
      }
    }
    age = age.join('|');

    let guestobj = {
      adulteresa: this.state.countAdult,
      enfantresa: this.state.countKid,
      childrenAges : age,
      roomCount: this.state.countRoom,
    }
    this.props.setGuestData(guestobj);
  }

  incrementRoom = (e, value) => {
    this.setState({
      [e]: value + 1
    })
  }

  decrementRoom = (e, value) => {
    if ( value > 0 ) {
      this.setState({
        [e]: value - 1
      })
    }
  }
  handleClickOutside = event => {
    if(!event.target.classList.contains("booknow-show-text")) {
      this.setState({
        showModal: false,
      })
    }
  }
  componentDidMount = () => {
    document.addEventListener('click', this.handleClickOutside, true);
  }

  render() {
    const {
      state: {
        showModal,
      }
    } = this;

    const kindsInfo = []
    for (var i = 0; i < this.state.countKid; i++) {
      kindsInfo.push(
        <div className="wrap" key={i}>
          <div className="text booknow-show-text"> {Drupal.t(`Kid ${i + 1} age`)} </div>
            <select
            className="booknow-show-text"
            onChange={(e) => this.handleChange(i,e)}
            id = {i+1}
            >
              <option value="1"> {Drupal.t("1 yrs")} </option>
              <option value="2"> {Drupal.t("2 yrs")} </option>
              <option value="3"> {Drupal.t("3 yrs")} </option>
              <option value="4"> {Drupal.t("4 yrs")} </option>
              <option value="5"> {Drupal.t("5 yrs")} </option>
              <option value="6"> {Drupal.t("6 yrs")} </option>
              <option value="7"> {Drupal.t("7 yrs")} </option>
              <option value="8"> {Drupal.t("8 yrs")} </option>
              <option value="9"> {Drupal.t("9 yrs")} </option>
              <option value="10"> {Drupal.t("10 yrs")} </option>
              <option value="11"> {Drupal.t("11 yrs")} </option>
            </select>
        </div>
      )
    }
    return (
 

      <div className = {"guest-wrapper" + (this.state.showModal ? ' show-guest-modal' : ' ')}>
        <label> { drupalSettings.ajaxPageState.theme ==="centara_cosi"? this.state.text_cosi: Drupal.t("Guest") }  </label>
        <div className = "booknow-show-text  input-wrapper">
          <input
            type = "textbox"
            className = "booknow-show-text guest"
            onFocus= {this.handleFocus}
            onChange = {this.handleFocus}
            value = {this.state.finalValue || this.state.countAdult + Drupal.t(" Adults \u00b7 ") + Drupal.t(" 0 Children \u00b7 ") + this.state.countRoom + Drupal.t(" rooms ") }
            placeholder={ this.state.countAdult + Drupal.t(" Adults \u00b7 ") + Drupal.t(" 0 Children \u00b7 ") + this.state.countRoom + Drupal.t(" rooms ") }
            readOnly
          />
          <span className="guest-icon"></span>
          <div className="modal-wrapper booknow-show-text">
            <div className="close-btn mobile-only" onClick={this.closeModal}></div>
            <div className="rooms counter-row">
              <div className="text booknow-show-text"> { Drupal.t("Rooms") } </div>
              <div className={"rooms-info booknow-show-text" +  (this.state.tooltip ? ' show-tool' : ' remove')}>
                <div className="tooltip-icon booknow-show-text" onClick = {this.showTooltip} ></div>
                <div className="tooltip-text booknow-show-text">
                  <div className="booknow-show-text">{Drupal.t("Maximum 9 adults per rooom")} </div>
                  <div className="booknow-show-text">{Drupal.t("Maximum 3 kids per room")} </div>
                </div>
              </div>
              <div className="counters">
                <div className="booknow-show-text minus" onClick = {() => this.decrementRoom('countRoom', this.state.countRoom)} > { Drupal.t("-") } </div>
                <div className="booknow-show-text value"> { this.state.countRoom } </div>
                <div className="booknow-show-text plus" onClick ={(this.state.countRoom <= 8) ? () => this.incrementRoom('countRoom', this.state.countRoom) : undefined} > { Drupal.t("+") } </div>
              </div>
            </div>
            <div className="adults counter-row">
              <div className="text booknow-show-text"> { Drupal.t("Adults") } </div>
              <div className="counters">
                <div className="minus booknow-show-text" onClick = {() => this.decrementRoom('countAdult', this.state.countAdult)} > { Drupal.t("-") } </div>
                <div className="value booknow-show-text"> { this.state.countAdult } </div>
                <div className="plus booknow-show-text" onClick = {(this.state.countAdult <= 8) ? () => this.incrementRoom('countAdult', this.state.countAdult) : undefined} > { Drupal.t("+") } </div>
              </div>
            </div>
            <div className="kids counter-row">
              <div className="text booknow-show-text"> { Drupal.t("Kids (0-12 yrs)") } </div>
              <div className="counters">
                <div className="minus booknow-show-text" onClick = {() => this.decrementRoom('countKid', this.state.countKid)} > { Drupal.t("-") } </div>
                <div className="value booknow-show-text"> { this.state.countKid } </div>
                <div className="plus booknow-show-text" onClick = {(this.state.countKid <= 8) ? () => this.incrementRoom('countKid', this.state.countKid) : undefined} > { Drupal.t("+") } </div>
              </div>
            </div>
            <div className="booknow-show-text kids-info-wrapper">
              { kindsInfo }
            </div>
            <div className="done-button btn--primary booknow-show-text" onClick = {this.closeModal}> {Drupal.t("Done")}</div>
          </div>
        </div>
      </div>
    );
  }
}

export default Guests;
